import { render, staticRenderFns } from "./YourProfilePictureForm.vue?vue&type=template&id=1b3f4580"
import script from "./YourProfilePictureForm.vue?vue&type=script&lang=js"
export * from "./YourProfilePictureForm.vue?vue&type=script&lang=js"
import style0 from "./YourProfilePictureForm.vue?vue&type=style&index=0&id=1b3f4580&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3f4580')) {
      api.createRecord('1b3f4580', component.options)
    } else {
      api.reload('1b3f4580', component.options)
    }
    module.hot.accept("./YourProfilePictureForm.vue?vue&type=template&id=1b3f4580", function () {
      api.rerender('1b3f4580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/YourProfilePictureForm.vue"
export default component.exports